import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getAuditHistory(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/admin/audits?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching audit history"
                    });
                }
            });
    },
    getFilterDropdownData() {
        return axios.get(constants.BASE_URL + "/admin/audits/filter-dropdowns", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getTableDataForRevision(revisionNumber) {
        return axios.get(constants.BASE_URL + "/admin/audits/revisions/"+ revisionNumber, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getTableHeaders(entityType) {
        return axios.get(constants.BASE_URL + "/admin/audits/entity-history/"+ entityType + "/table-header", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getEntityAuditHistory(input, entityType, revisionTypes) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/admin/audits/entity-history/"+ entityType + "?" + input, {params:{revisionTypes:revisionTypes, timezone:Intl.DateTimeFormat().resolvedOptions().timeZone}}, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching history"
                    });
                }
            });
    },
}
